import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import { centreType } from '../../types'
import BrowseStores from './browse-stores'

export default class BrowseStoresCategory extends Component {
  static propTypes = {
    centre: centreType,
    match: PropTypes.object,
  }

  renderStores = props => <BrowseStores centre={this.props.centre} {...props} />

  render() {
    const { props } = this

    return (
      <Switch>
        <Route
          path={`${props.match.path}/:a/:b/:c/:category`}
          component={this.renderStores}
        />
        <Route
          path={`${props.match.path}/:a/:b/:category`}
          component={this.renderStores}
        />
        <Route
          path={`${props.match.path}/:a/:category`}
          component={this.renderStores}
        />
        <Route
          path={`${props.match.path}/:category`}
          component={this.renderStores}
        />
        <Route component={this.renderStores} />
      </Switch>
    )
  }
}
